const BASE = process.env.REACT_APP_APIURL || 'http://localhost:4000/';
const api = (path) => `${BASE.replace(/\/$/, '')}/${path}`;

export class ModuloApi {
  async getAllModulo() {
    const res = await fetch(api('modulo'));
    if (!res.ok) throw new Error(`getAllModulo: ${res.status}`);
    return res.json();
  }

  async getModuloById(id) {
    const res = await fetch(api(`modulo/${id}`));
    if (!res.ok) throw new Error(`getModuloById: ${res.status}`);
    return res.json();
  }

  async addModulo(data) {
    const res = await fetch(api('modulo'), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data),
    });
    if (!res.ok) throw new Error(`addModulo: ${res.status}`);
    return res.json();
  }

  async updateModulo(id, data) {
    const res = await fetch(api(`modulo/${id}`), {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data),
    });
    if (!res.ok) throw new Error(`updateModulo: ${res.status}`);
    return res.json();
  }

  async deleteModulo(id) {
    const res = await fetch(api(`modulo/${id}`), { method: 'DELETE' });
    if (!res.ok) throw new Error(`deleteModulo: ${res.status}`);
    return { success: true };
  }
}
